const presetElements = [
  {
    type: 'slider',
    element: 'el-slider'
  },
  {
    type: 'slider-disabled',
    element: 'el-slider',
    attrs: {
      disabled: true
    }
  }
]

export default presetElements
